import React from "react";
import {ModalDefault} from "../../../containers/ModalDefault";
import {ProfileImageUpdating} from "../ImageUpdating/profileImageUpdating/ProfileImageUpdating";
import {ProfileDataUpdatingBlock} from "../dataUpdating/ProfileDataUpdatingBlock";
import {styles} from "./Styles";

export const ProfileUpdatingModal = ({isOpen, onRequestClose, imageUpdatingState, profileUpdatingState}) => {

    return (
        <ModalDefault isOpen={isOpen} onRequestClose={()=>onRequestClose()}>
            <div style={{
                ...styles.modalContainer
            }}>
                {imageUpdatingState && <ProfileImageUpdating/>}
                {profileUpdatingState && <ProfileDataUpdatingBlock 
                    onRequestClose={()=>onRequestClose()}/>
                }
            </div>
        </ModalDefault>
    )
}